import Image from 'next/image'
import wfnLogo from './wfn.png'

type IconProps = {
  className?: string
}

const WfnLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={wfnLogo} alt="WFN Logo" height={48} {...attributes} />
}

export default WfnLogo
